import styled from 'styled-components'

export const NewsletterWrapper = styled.div`
  height: 400px;
  background: conic-gradient(
    at center 82%,
    var(--blue10) 0deg 86deg,
    var(--blue6) 86deg 274deg,
    var(--blue10) 274deg 0deg
  );
`

export const NewsletterContainer = styled.div`
  margin: 0 auto;
  padding: 4rem 6rem;
  text-align: center;

  p {
    font-size: 36px;
    font-weight: 700;
    line-height: 46px;
    color: var(--light);
    margin-bottom: 8rem;
  }

  a {
    all: unset;
    background-color: var(--orange5);
    color: var(--light);
    font-weight: 400;
    font-size: 18px;
    line-height: 22px;
    border-radius: 30px;
    padding: 1.2rem 1.2rem;
    cursor: pointer;
  }

  @media (max-width: 1366px) {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  @media only screen and (max-width: 1050px) {
    p {
      font-size: 32px;
      line-height: 39px;
    }
  }

  @media only screen and (max-width: 700px) {
    h2 {
      font-size: 14px;
    }

    p {
      font-size: 24px;
      line-height: 29px;
    }
  }
`
